<ws-modal-wrapper [headerLabel]="headerLabel" acceptLabel="Save" (save)="save()" (cancel)="cancel()"
                  [disableSave]="!isSaveable() || loading"
                  [loading]="loading">
    <div class="ws-flex-container-vertical ws-stretch">
        <table class="cc-bulk-update-fields">
            <tbody>
                <tr>
                    <td>
                        <label>Category:</label>
                    </td>
                    <td>
                        <tax-authority-bulk-update-action [requiredField]="true"
                                                          [(fieldAction)]="taBulkUpdateRequest.categoryAction"></tax-authority-bulk-update-action>
                    </td>
                    <td>
                        <select class="form-select form-select-sm"
                                style="width: auto;"
                                [(ngModel)]="taBulkUpdateRequest.taxAuthorityCategoryId"
                                [disabled]="isDisabled(taBulkUpdateRequest.categoryAction)">
                            <option [ngValue]="undefined"></option>
                            @for (category of categories; track category) {
                                <option [ngValue]="category.id">{{ category.label }}</option>
                            }
                        </select>
                    </td>
                </tr>
                <tr>
                    <td>
                        <label>Taxable Assessment:</label>
                    </td>
                    <td>
                        <tax-authority-bulk-update-action [requiredField]="true"
                                                          [(fieldAction)]="taBulkUpdateRequest.taxableAssessmentTypeAction"></tax-authority-bulk-update-action>
                    </td>
                    <td>
                        <div>
                            <select class="form-select form-select-sm"
                                    style="width: auto;"
                                    [(ngModel)]="taBulkUpdateRequest.taxableAssessmentTypeId"
                                    [disabled]="isDisabled(taBulkUpdateRequest.taxableAssessmentTypeAction)">
                                @for (option of taxableAssessments; track option) {
                                    <option [ngValue]="option.id">{{ option.label }}</option>
                                }
                            </select>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td class="ws-vertical-align-top">
                        <label class="my-1">Exemptions Honored:</label>
                    </td>
                    <td class="ws-vertical-align-top">
                        <tax-authority-bulk-update-action [requiredField]="true"
                                                            [(fieldAction)]="taBulkUpdateRequest.taxAuthorityExemptionTypeAction"></tax-authority-bulk-update-action>
                    </td>
                    <td>
                        <div class="radio my-0">
                            <label>
                                <input type="radio"
                                        name="taxAuthorityExemptionType"
                                        [value]="exemptions.allExemptions"
                                        [(ngModel)]="taBulkUpdateRequest.taxAuthorityExemptionTypeId"
                                        [disabled]="isDisabled(taBulkUpdateRequest.taxAuthorityExemptionTypeAction)">
                                All
                            </label>
                        </div>
                        <div class="radio my-0">
                            <label>
                                <input type="radio" name="taxAuthorityExemptionType"
                                        [value]="exemptions.noExemptions"
                                        [(ngModel)]="taBulkUpdateRequest.taxAuthorityExemptionTypeId"
                                        [disabled]="isDisabled(taBulkUpdateRequest.taxAuthorityExemptionTypeAction)">
                                None
                            </label>
                        </div>
                        <div class="radio my-0">
                            <label>
                                <input type="radio"
                                        name="taxAuthorityExemptionType"
                                        [value]="exemptions.certainExemptions"
                                        [(ngModel)]="taBulkUpdateRequest.taxAuthorityExemptionTypeId"
                                        [disabled]="isDisabled(taBulkUpdateRequest.taxAuthorityExemptionTypeAction) || multipleStatesSelected === true">
                                Certain Exemptions
                            </label>
                        </div>
                        @if (allowedExemptions && allowedExemptions.length > 0) {
                            <div>
                                <checkbox-list [(ngModel)]="allowedExemptions"
                                                [disabled]="isDisabled(taBulkUpdateRequest.taxAuthorityExemptionTypeAction) || taBulkUpdateRequest.taxAuthorityExemptionTypeId !== exemptions.certainExemptions || multipleStatesSelected === true">
                                </checkbox-list>
                            </div>
                        }
                        @if (allowedExemptions && allowedExemptions.length === 0 && multipleStatesSelected === false) {
                            <div class="checkbox my-0">
                                <label>(No exemptions defined for the selected Tax Authorities)</label>
                            </div>
                        }
                        @if (multipleStatesSelected === true) {
                            <div class="checkbox ms-0 my-0">
                                <label>(Multiple states selected. Cannot update certain exemptions.)</label>
                            </div>
                        }
                    </td>
                </tr>
                <tr>
                    <td>
                        <label>&nbsp;</label>
                    </td>
                    <td>
                        <label>&nbsp;</label>
                    </td>
                    <td>
                        <div class="my-0">
                            <ws-tri-state-checkbox [(ngModel)]="taBulkUpdateRequest.allowExemptionsOnAlternateAV"
                                                    [disabled]="isDisabled(taBulkUpdateRequest.taxAuthorityExemptionTypeAction)">
                            </ws-tri-state-checkbox>
                            Also honor exemptions on Alternate AV
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>
                        <label>Typical Certification Date:</label>
                    </td>
                    <td>
                        <tax-authority-bulk-update-action [requiredField]="false"
                                                          [(fieldAction)]="taBulkUpdateRequest.certificationDateAction"></tax-authority-bulk-update-action>
                    </td>
                    <td>
                        <div>
                            <select class="form-select form-select-sm"
                                    style="width: auto; display: inline-block;"
                                    [(ngModel)]="taBulkUpdateRequest.certificationMonth"
                                    [disabled]="isDisabled(taBulkUpdateRequest.certificationDateAction)">
                                <option [ngValue]="undefined"></option>
                                @for (option of certificationMonths; track option) {
                                    <option [ngValue]="option">{{ option }}</option>
                                }
                            </select>
                            <span>/</span>
                            <select class="form-select form-select-sm"
                                    style="width: auto; display: inline-block;"
                                    [(ngModel)]="taBulkUpdateRequest.certificationDay"
                                    [disabled]="isDisabled(taBulkUpdateRequest.certificationDateAction)">
                                <option [ngValue]="undefined"></option>
                                @for (option of certificationDays; track option) {
                                    <option [ngValue]="option">{{ option }}</option>
                                }
                            </select>
                            <select class="form-select form-select-sm"
                                    style="width: auto; display: inline-block;"
                                    [(ngModel)]="taBulkUpdateRequest.certificationType"
                                    [disabled]="isDisabled(taBulkUpdateRequest.certificationDateAction)">
                                <option [ngValue]="undefined"></option>
                                @for (option of certificationTypes; track option) {
                                    <option [ngValue]="option.id">{{ option.label }}</option>
                                }
                            </select>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>
                        <label>Obtain In Advance:</label>
                    </td>
                    <td>
                        <tax-authority-bulk-update-action [requiredField]="true"
                                                          [(fieldAction)]="taBulkUpdateRequest.obtainInAdvanceAction"></tax-authority-bulk-update-action>
                    </td>
                    <td>
                        <input type="checkbox" [(ngModel)]="taBulkUpdateRequest.obtainInAdvance"
                               [disabled]="isDisabled(taBulkUpdateRequest.obtainInAdvanceAction)">
                    </td>
                </tr>
                <tr>
                    <td>
                        <label>Default Annual Increase:</label>
                    </td>
                    <td>
                        <tax-authority-bulk-update-action [requiredField]="true"
                                                          [(fieldAction)]="taBulkUpdateRequest.defaultAnnualIncreaseAction"></tax-authority-bulk-update-action>
                    </td>
                    <td>
                        <input type="number" class="form-control" style="width: auto; text-align: right;"
                               [(ngModel)]="defaultAnnualIncreaseDisplay" (blur)="defaultAnnualIncreaseBlur()"
                               [disabled]="isDisabled(taBulkUpdateRequest.defaultAnnualIncreaseAction)">
                    </td>
                </tr>
                <tr>
                    <td>
                        <label>YoY % Change:</label>
                    </td>
                    <td>
                        <tax-authority-bulk-update-action [requiredField]="true"
                                                          [(fieldAction)]="taBulkUpdateRequest.yoyAction"></tax-authority-bulk-update-action>
                    </td>
                    <td>
                        <div>
                            <select class="form-select form-select-sm"
                                    style="width: auto; display: inline-block;"
                                    [(ngModel)]="taBulkUpdateRequest.taxYear"
                                    [disabled]="isDisabled(taBulkUpdateRequest.yoyAction)">
                                @for (option of selectableTaxYears; track option) {
                                    <option [ngValue]="option">{{ option }}</option>
                                }
                            </select>
                            <span> </span>
                            <input type="text"
                                   class="form-control"
                                   style="width: auto; display: inline-block; text-align: right;"
                                   [(ngModel)]="yoyPercentDisplay"
                                   (blur)="yoyPercentBlur()"
                                   [disabled]="isDisabled(taBulkUpdateRequest.yoyAction)">
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</ws-modal-wrapper>
